import { useContext, useEffect } from 'react';

import { analyticsMethods } from '../helpers/constants';
import autofillParser from '../helpers/autofillParser';
import DataContext from '../store/dataContext';
import UiContext from '../store/uiContext';
import { useSkeleton } from './useSkeleton';

import { useAnalyticsMethodApi } from './useAxios';
import { useProduct } from './useProduct';

const useAutofill = () => {
  const {
    apiEmailResponse,
    updateUserCardId,
    updateIsAutofill,
    isAutofill,
    cartId,
    updateShippingName,
    updateShippingAddress1,
    updateShippingAddress2,
    updateCompanyName,
    isLoggedIn,
  } = useContext(DataContext);
  const { updateCheckoutState, TO_SHIPPING_ADDRESS_ADD, TO_CARD_ADD } = useContext(UiContext);
  const { apiPostAnalyticsMethod } = useAnalyticsMethodApi();
  const { allDigital } = useProduct();
  const { setShowLoading } = useSkeleton();

  const handleNoAutofill = () => {
    updateIsAutofill(false);
    updateCheckoutState(TO_SHIPPING_ADDRESS_ADD);
  };

  const handleUi = () => {
    updateCheckoutState(TO_CARD_ADD);
  };

  const handleData = parsedSuggestions => {
    updateIsAutofill(true);
    if (!allDigital()) {
      if (isLoggedIn && parsedSuggestions?.address1 === undefined) {
        setShowLoading(false);
      } else if (!isAutofill) {
        setShowLoading(true);
      }
      updateShippingName(parsedSuggestions?.name);
      updateShippingAddress1(parsedSuggestions?.address1);
      updateShippingAddress2(parsedSuggestions?.address2);
      updateCompanyName(parsedSuggestions?.shipCompany);
    }
    updateUserCardId(parsedSuggestions?.cardId);
  };

  const handleAutofill = () => {
    const parsedSuggestions = autofillParser(apiEmailResponse);
    if (parsedSuggestions.isAvailable) {
      handleUi();
      handleData(parsedSuggestions);
      apiPostAnalyticsMethod(cartId, analyticsMethods.autofill_accepted);
    } else if (isLoggedIn) {
      updateCheckoutState(TO_SHIPPING_ADDRESS_ADD);
      setShowLoading(false);
    }
  };

  useEffect(() => {
    const hasApiEmailResponse = apiEmailResponse && Object.values(apiEmailResponse).length > 0;
    if (hasApiEmailResponse) {
      handleAutofill();
    }
  }, [apiEmailResponse]);

  return { handleNoAutofill, handleAutofill };
};

export default useAutofill;
